import { setupAbstractContentBuilder } from "./abstract-content-builder.js";
import { addCollapsibleList } from "./collapsible-list-builder-api.js";
import { addListNode, addNode, addTextNode } from "./node-builder-methods.js";
import { addTable } from "./table-builder-api.js";
const firstLetterUpperCase = (str) => `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
const setupContentBuilder = (generateId) => {
  class RicosContentBuilder {
  }
  const builderApis = setupAbstractContentBuilder(
    generateId,
    addTextNode,
    addListNode,
    addNode,
    addTable,
    addCollapsibleList,
    (name) => `add${firstLetterUpperCase(name)}`
    // addParagraph, addTable, ...
  );
  return {
    RicosContentBuilder,
    ...builderApis
  };
};
export {
  setupContentBuilder
};
//# sourceMappingURL=ricos-content-builder.js.map
